import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

const Layout = styled.div`
width: 100%;
padding: 25px;

> div: first-child {
  width: 100%;
  max-width: 1246px;
  margin: auto;
}
`;

const Container = styled.div`
width: 100%;
display: flex;
flex-wrap: wrap;
`;

const Header = styled.div`
width: 100%;
display: flex;
background: white;
margin-bottom 10px;
height: 60px;
>div{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .profile{
      width: 30px;
      height: 22px;
      margin: auto 10px auto 15px;
      >img{
        width: 100%;
        height: 100%;
      }
    }
    .count{
      font-family: lato;
      font-size: 18px;
      line-height: 24px;
      color:#184A61;
      align-items: center;
      display: flex;
    }
  }

`;

const StyledModal = styled(Modal)`
@media (min-width: 576px){
  .modal-dialog {
    max-width:100% !important;
  }}
  .modal-dialog {
    transform: ${({transform}) => transform ? 'translate(0, 15vh) translate(0, -15%) !important' : 'translate(0, 50vh) translate(0, -50%) !important'};
    margin: ${({change}) => change ? '150px auto' : '0 auto'};
    // box-shadow: 0 5px 15px rgba(0,0,0,.5);
    @media (min-width: 576px){
      .modal-dialog {
        max-width:100% !important;
      }}
    .modal-content{
      border:none;
      box-shadow: 0 5px 15px rgba(0,0,0,.5);
      width: ${({width}) => width ? width : '400px'};
      padding: ${({paddingV}) => paddingV ? paddingV : '20px'};
    }
    @media (max-height: 460px) {
      transform: none !important;
      margin: 30px auto;
    }
    width: ${({width}) => width ? width : '490px'};
    height: ${({change, height}) => height? height :change ? '573px' : '473px'};
    @media (max-width: 500px){
      width: 95%;
      height: auto;
    }
  }

  .modal-body{
    padding: ${({padding}) => padding ? padding : '25px 0 25px 0'};
  }
  
  .modal-container {
   width: 100%;
   display: block;
   border: none;
   > div: nth-child(1) {
    width: 100%;
    height: 0px;
    display: flex;
    justify-content: flex-end;
    >img{
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin: 15px 15px 0 0;
    }
   }
   > div: nth-child(2) {
    width: 100%;
    display:flex;
    justify-content: center;
    font-family: lato;
    font-size: 24px;
    line-height: 24px;
    color:#184A61;
    text-decoration: underline;
    margin-top: 35px;
   }
  }
  .teamWrapper{
    display:flex;
    width:100%;
    flex-wrap:wrap;
    padding: 16px 24px;
    height: ${({heightV}) => heightV ? heightV : ''};
    overflow-y: ${({scroll}) => scroll ? 'scroll' : ''}  ;

    .teamNameDiv{
      width:100%;
      .count{
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0%;
        text-align: right;
        vertical-align: middle;
        width:100%;
        display:flex;
        margin-bottom:12px;
        color:#BDBDBD;
        justify-content:flex-end;
        }
    }
  }
`;





const StyledModalV1 = styled(Modal)`
@media (min-width: 576px){
  .modal-dialog {
    max-width:100% !important;
  }}
  .modal-dialog {
    transform: ${({transform}) => transform ? 'translate(0, 15vh) translate(0, -15%) !important' : 'translate(0, 50vh) translate(0, -50%) !important'};
    margin: ${({change}) => change ? '150px auto' : '0 auto'};
    // box-shadow: 0 5px 15px rgba(0,0,0,.5);
    @media (min-width: 576px){
      .modal-dialog {
        max-width:100% !important;
      }}
    .modal-content{
      background:#F8F8F8;
      border-radius: 12px;
      border:none;
      box-shadow: 0 5px 15px rgba(0,0,0,.5);
      width: ${({width}) => width ? width : ''};
      padding: ${({paddingV}) => paddingV ? paddingV : ''};
    }
    @media (max-height: 460px) {
      transform: none !important;
      margin: 30px auto;
    }
    width: ${({width}) => width ? width : '490px'};
    height: ${({change, height}) => height? height :change ? '573px' : '473px'};
    @media (max-width: 500px){
      width: 95%;
      height: auto;
    }
  }

  .modal-body{
    padding: ${({padding}) => padding ? padding : '25px 0 25px 0'};
  }
  
  .modal-container {
   width: 100%;
   display: block;
   border: none;
   > div: nth-child(1) {
    width: 100%;
    height: 0px;
    display: flex;
    justify-content: flex-end;
    >img{
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin: 15px 15px 0 0;
    }
   }
   > div: nth-child(2) {
    width: 100%;
    display:flex;
    justify-content: center;
    font-family: lato;
    font-size: 24px;
    line-height: 24px;
    color:#184A61;
    text-decoration: underline;
    margin-top: 35px;
   }
  }
`;

const CalendarHeader = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  background: ${({style}) => style && style.background ? style.background : '#FEFEFE'};
  border-bottom:${({style}) => style && style.borderBottom ? style.borderBottom : ''};
  border-radius: 12px 12px 0 0;
  > div: nth-child(1) {
    width:100%;
    font-family: lato;
    font-size: 18px;
    line-height: 24px;
    color:${({deleteInactiveUser}) => deleteInactiveUser ? '#184A61' : '#ffff'};
    margin: auto;
    display: flex;
    justify-content: center;
  }
 
`


const CalendarWrapperV1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${'' /* margin-bottom: 12px; */}
  margin:auto;
  ${'' /* background-color: #fff; */}

  .headerTitle {
    color: #184A61;
    text-align: center;
    min-width: 140px;
    font-family: "Lato";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
  }
`;


const ButtonV1 = styled.span`
  padding: 8px 12px;
  ${
  "" /* background-color: ${(props) => (props.primary ? "#39c0ed" : "#e0e0e0")}; */
}
  ${"" /* color: ${(props) => (props.primary ? "#fff" : "#333")}; */}
  color:  #184A61;

  /* Primary - Lato/Caption */
  font-family: "Lato";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  ${"" /* border-radius: 40px; */}
  ${"" /* border: 1px solid  #EFEFEF; */}
${'' /* background:  #FEFEFE; */}
  cursor: pointer;
  margin: 5px;

  ${
  "" /* &:hover {
    background-color: ${(props) => (props.primary ? "#1d8cb6" : "#d6d6d6")};
  } */
}
`;



const CalendarHeaderV1 = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  padding:16px 16px 0px 16px;
  justify-content: center;
  align-items: center;
  background: ${({style}) => style && style.background ? style.background : '#FEFEFE'};
  border-bottom:${({style}) => style && style.borderBottom ? style.borderBottom : ''};
  border-radius: 12px 12px 0 0;
  .popUpHeader {
    width:100%;
    font-family: ${({isFontType}) => isFontType ? isFontType : 'lato'};
    font-weight:700;
    font-size: 18px;
    line-height: 24px;
    color:${({deleteInactiveUser,color}) => deleteInactiveUser ? '#184A61' : color ? color : '#ffff'};
    margin: auto;
    display: flex;
    justify-content: ${({isContent}) => isContent ? isContent : 'center'};
  }
 
`

const CalendarWrapper = styled.div`
  padding: ${({padding}) => padding ? padding : '0px'};
  .subtext{
    font-family: lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    color: #184A6199;
    padding:0 0 25px 0;
    text-align:center;
  }
  .textValue{
    color: #184A61;
    text-align: center;
    font-family: lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    display:flex;
    align-items:center;
  }
`

const ConfirmVisitText = styled.div`
  width: ${({deleteInactiveUser}) => deleteInactiveUser ?  '70%' : '100%'};
  font-family: ${({isTopData}) => isTopData ?  'lato' : 'lato'};
  ${'' /* font-family: lato; */}
  font-size: 16px;
  line-height: 24px;
  color:#184A61;
  display: ${({display}) => display ? display : 'flex'};
  justify-content: center;
  text-align: center;
  margin: ${({deleteInactiveUser,isTopData, margin}) => margin?margin: deleteInactiveUser ?  ' 25px auto 25px auto' : isTopData? '30px 0px 20px 0px' : ' 16px 0px 16px 0px'};
  >span{
    display: contents;
    font-family: lato;
    font-size: 16px;
    line-height: 24px;
    color:#184A61;
    font-weight: 700; 
  }
  .note{
    font-family: lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: center;
    color: #184A6199;
  }
  .danger{
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #DA6C74;
  }
  .text{
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #184A61;
    margin-bottom:20px;
  }
`




const ConfirmVisitTextV1 = styled.div`
  width: 100%;
  font-family: Lato;
  ${'' /* font-family: lato; */}
  font-size: 16px;
  line-height: 20px;
  color: ${({textColor}) => textColor ? textColor : '#184A61'};
  font-weight: 400;
  display: ${({display}) => display ? display : 'flex'};
  justify-content: center;
  text-align: center;
  margin: ${({isMargin}) => isMargin ? isMargin : '20px 0px '};
  
`
const DividerLine = styled.div`
    width: 752px;
    height: 0px;
    border: 1px solid rgba(0, 92, 135, 0.10);
`;

const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 20px 0px 12px 0px;
    color: rgba(0, 92, 135, 0.60);
    font-family: lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
`;

const TableData = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 20px 0px 12px 0px;
    color: #184A61;
    font-family: lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
`;



const ButtonContainer = styled.div`
  width: 100%;
  justify-content: center;
  margin: auto;
  display: flex;
  flex-wrap:wrap;
  gap:16px;
`;



const ButtonContainerV1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px; 
`;


const ButtonContainerV3 = styled.div`
  width: 100%;
  justify-content: center;
  gap:16px;
  margin: auto;
  display: flex;
`;

const Button = styled.div`
  width: ${({width}) => width ? width : '172px'};
  height: ${({height}) => height ? height : '50px'};
  background: ${({background}) => background ? background : '#DA6C74'};
  font-family: lato;
  font-size: 18px;
  line-height: 24px;
  color: ${({color}) => color ? color : '#fff'};
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 6px
  border: ${({border}) => border ? "1px solid #DA6C74" : 'none'};
`;

const ButtonV2 = styled.div`
  width: ${({width}) => width ? width : '205px'};
  height: ${({height}) => height ? height : '50px'};
  background: ${({background}) => background ? background : 'rgba(253, 113, 117, 1)'};
  margin: ${({margin}) => margin ? margin : ''};
  font-family: lato;
  font-size: 18px;
  line-height: 24px;
  color: ${({color}) => color ? color : '#fff'};
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  border: ${({border}) => border ? "1px solid #007AB1" : 'none'};
  :hover {
    background: ${({backgroundHover}) => backgroundHover ? backgroundHover : ''};
    color: ${({colorHover}) => colorHover ? colorHover : ''};
  }
`;


const ButtonV3 = styled.div`
  width: ${({width}) => width ? width : '205px'};
  height: ${({height}) => height ? height : '40px'};
  background: ${({background}) => background ? background : 'rgba(253, 113, 117, 1)'};
  margin: ${({margin}) => margin ? margin : ''};
  font-family: Lato;
  padding:12px 16px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${({color}) => color ? color : '#fff'};
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  border: ${({border}) => border ? "1px solid #007AB1" : 'none'};
  :hover {
    background: ${({backgroundHover}) => backgroundHover ? backgroundHover : ''};
    color: ${({colorHover}) => colorHover ? colorHover : ''};
  }
`;


const NoData = styled.div`
  width: 100%;
  font-size: 16px;
  font-family: lato;
  color: #184A61
`;

const Backdrop = styled.div`
  width: 100%;
  height: 0px;
  position: relative;
  bottom: 175px;
  >div{
    width: 100%;
    height: 700px;
    background: transparent;
    position: relative;
  }
`;

const GridCard = styled.div`
  width: 100%;
  min-height: 300px;
  border-radius: 12px;
  padding: 16px 8px;
 
.wellness-champion{
  width: 100%;
  height: 20px;
  margin-bottom: 5px;

  >div{
  width: 100%;
  ${'' /* background: linear-gradient(90deg, rgb(0, 177, 188) -1.11%, rgb(117, 217, 163) 97.46%); */}
  ${'' /* background: ${({deleted}) => deleted ? '#FD7175' :'linear-gradient(90deg, rgb(0, 177, 188) -1.11%, rgb(117, 217, 163) 97.46%)'}; */}
  margin-bottom: 5px;
  display: flex;
  font-family: lato;
  font-size: 14px;
  line-height: 20px;
  color: #418856;
  justify-content: center;
  align-items: center;
  border-radius: 6px 6px 0 0;
  font-weight: 600;
  }
}
.menu-button{
  width:100%;
  height: 0px;
  display: flex;
  justify-content: flex-end;
  >img{
    height: 6px;
    width: 24px;;
    cursor: pointer;
    margin-right: 10px;
    margin-top: -8px;
  }
}
.remove-button{
  width: 100%;
  height: 0px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  >div{
    width:118px;
    height:40px;
    background: white;
    border-radius: 6px;
    filter: drop-shadow(rgba(58, 58, 58, 0.2) 5px 4px 10px);

  font-family: lato;
  font-size: 14px;
  line-height: 20px;
  color:#184A61;
  display: flex;
  justify-content:center;
  align-items: center;
  margin: 10px 10px 0 0;
  }
}
.profile{
  width: 100%;
  margin-bottom :16px;
  >div{
    width: 80px;
    height: 80px;
    margin: auto;
    >img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.name{
  font-family: lato;
  font-size: 18px;
  line-height: 24px;
  color:#184A61;
  width: 100%;
  display: flex;
  margin-bottom :8px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight:700
}
.department{
  font-family: lato;
  font-size: 16px;
  line-height: 20px;
  color: #184A61;
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  justify-content: center;
  text-align: center;
  height: 20px;
}
.no-department{
  font-family: lato;
  font-size: 14px;
  line-height: 20px;
  color:#184A61;
  width: 100%;
  display: flex;
  margin-bottom 10px;
  justify-content: center;
  align-items: center;
}
.wellness-card{
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  justify-content: center;
  >div{
    width: 32px;
    height: 32px;
    display: flex;
    margin-right: 5px;
    ${'' /* background: linear-gradient(360deg,#1E6481 0%,#0D425C 60.94%,#022C43 100%); */}
    border-radius: 6px;
    >img{
      width: 24px;
      height: 24px;
      margin: auto;
      filter: invert(55%) sepia(25%) saturate(600%) hue-rotate(170deg) brightness(90%) contrast(90%);
    }
    .hover-card{
      width: 0px;
      height: 0px;
      position: relative;
      display: block;
      >div{
        min-width: 90px;
        max-width: 120px;
        min-height: 25px;
        position: relative;
        right: 50px;
        bottom: 27px;
        background: rgba(156, 156, 156, 0.79);

        font-family: lato;
        font-size: 12px;
        line-height: 12px;
        color: white;
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        border-radius: 6px;
        padding: 5px 7px;
      }
    }
  }
}
.mutual-buddies{
  width: 100%;
  background: #fff;
  >div{
    width: 100%;
    display: flex;
    justify-content: center;
    height: 50px;
    .text{
      font-family: lato;
      font-size: 16px;
      line-height: 20px;
      align-items: center;
      margin: auto 0px;
      margin-right: 10px;
      color: #184A61;
    }
    .no-text{
      font-family: lato;
      font-size: 16px;
      line-height: 20px;
      align-items: center;
      margin: auto 0px;
      margin-right: 10px;
      color: #184A61;
    }
    .profile-image-card{
      display: flex;
      margin-left: 12px;
      >img{
        width: 34px;
        height: 34px;
        margin: auto 0px;
        border-radius: 50%;
        margin-left: -12px;
        border: 1px solid #DCDCDC;
      }
      .count{
        background: #FEFEFE;
        font-family: lato;
        font-size: 12px;
        color: #184A61;
        padding: 0px 8px;
        height: 34px;
        width: 34px;
        margin: auto;
        border-radius: 50%;
        margin-left: -12px;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: flex;
        border: 1px solid #DCDCDC;
      }
    }
  }
}
.button-cotainer{
  width: 100%;
  margin: 0px auto;
  padding: 10px 0px;
}
`;

const NoBuddy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-container: center;
  .greyCircle{
    width: 341px;
    height: 341px;
    border-radius: 50%;
    background: rgba(156, 156, 156, 0.3);
    margin-top: 100px;
  }
  .nobuddyInfo{
    font-family: 'lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #184A61; 
    margin-top: 40px;
    margin-bottom: 35px;  
  }
  .goTo-Community{
    width: 320px;
    height: 50px;
    background: #69C2FF;
    border-radius: 3px;
    font-family: 'lato';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    border: none;
  }
`;

export {Layout, Container, Header, CalendarWrapper,CalendarWrapperV1,ButtonV1, ButtonContainer,ButtonContainerV1, ConfirmVisitText, CalendarHeader, StyledModal, Button, NoData, Backdrop, DividerLine , TableHeader, TableData, GridCard, NoBuddy, ButtonV2,ButtonContainerV3,ButtonV3,ConfirmVisitTextV1,CalendarHeaderV1,StyledModalV1};